module.exports = __webpack_public_path__ + "img/mother-sample.c8162620.png";